import { useState, useEffect, useRef } from "react";
import { EditorState, convertToRaw, ContentState, convertFromHTML, } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";

const DescriptionEditor = ({ onChange, placeholder, value }) => {
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const lastEmittedHtmlRef = useRef("");

  const handleEditorChange = (newEditorState) => {
    setEditorState(newEditorState);
    const htmlContent = draftToHtml(convertToRaw(newEditorState.getCurrentContent()));
    lastEmittedHtmlRef.current = htmlContent;
    if (onChange) {
      onChange(htmlContent);
    }
  };

  useEffect(() => {
    const htmlValue = String(value || "");
    if (htmlValue === lastEmittedHtmlRef.current) {
      return;
    }
    if (!htmlValue.trim()) {
      setEditorState(EditorState.createEmpty());
      return;
    }

    const blocksFromHTML = convertFromHTML(htmlValue);
    const content = ContentState.createFromBlockArray(blocksFromHTML);
    const nextEditorState = EditorState.createWithContent(content);
    setEditorState(nextEditorState);
  }, [value]);

  return (
    <Editor
      editorState={editorState}
      placeholder={placeholder}
      toolbarClassName="toolbarClassName"
      wrapperClassName="wrapperClassName"
      editorClassName="editorClassName"
      wrapperStyle={{ direction: "ltr", textAlign: "left" }}
      toolbarStyle={{ direction: "ltr", textAlign: "left" }}
      editorStyle={{ direction: "ltr", textAlign: "left", unicodeBidi: "normal" }}
      textAlignment="left"
      onEditorStateChange={handleEditorChange}
    />
  );
};

export default DescriptionEditor;